export default function Spinner({ size = 'md', tone = 'primary', className = '' }) {
  const sizes = { sm: 'h-4 w-4 border-2', md: 'h-8 w-8 border-2', lg: 'h-12 w-12 border-[3px]' };
  const tones = { primary: 'border-primary border-t-transparent', white: 'border-white border-t-transparent' };

  return (
    <div
      role="status"
      aria-label="Loading"
      className={`animate-spin rounded-full ${tones[tone]} ${sizes[size]} ${className}`}
    />
  );
}

export function FullScreenSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <Spinner size="lg" />
    </div>
  );
}
